import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import {
  BaseAllParam,
  SaveServiceParamParams,
  UpdateServiceParamParams,
  DeleteServiceParamParams,
  DetailServiceParamBackData,
  MapListParams,
  MapListResult,
  AppVersionItem
} from '@/typings/api/systemSetting'

/**
 * **************************************  **************************************
 */
// 查询所有业务参数
export function baseAll(data: BaseAllParam, headers?: any) {
  return request({
    url: '/base/api/bizParam/all',
    data,
    method: 'POST',
    headers
  })
}
export function saveServiceParam(data: SaveServiceParamParams, headers?: any) {
  return request({
    url: '/base/api/bizParam/save',
    data,
    method: 'POST',
    headers
  })
}
export function updateServiceParam(data: UpdateServiceParamParams, headers?: any) {
  return request({
    url: '/base/api/bizParam/update',
    data,
    method: 'POST',
    headers
  })
}
export function deleteServiceParam(data: DeleteServiceParamParams) {
  return request.post<AxiosResult>('/base/api/bizParam/delete', data)
}
export function getIdServiceParam(data: DeleteServiceParamParams) {
  return request.post<AxiosResult<DetailServiceParamBackData>>('/base/api/bizParam/getBizParamById', data)
}

/**
 * ************************************** 地图管理 **************************************
 */
//  获取地图设置
export function getMapConfig() {
  return request.post<MapListResult>('/base/api/sysConfig/getMapConfig')
}
//  修改地图设置
export function updateMapConfig(data: MapListParams[]) {
  return request.post<AxiosResult>('/base/api/sysConfig/updateMapConfig', data)
}
/**
 * ************************************** APP版本管理 **************************************
 */
//  获取App版本信息
export function getAppVersion() {
  return request.post<MapListResult>('/base/api/sysConfig/getAppVersionConfig')
}
//  修改App版本信息
export function updateAppVersion(data: AppVersionItem) {
  return request.post<AxiosResult>('/base/api/sysConfig/updateAppVersionConfig', data)
}
